import React from 'react';
import {
  List,
  Datagrid,
  DateField,
  FunctionField,
  useRedirect,
  TextField as RaTextField,
  ReferenceField,
} from 'react-admin';
import { CustomActions, IndexField, FilterBar } from '../../components';

import {
  Card,
  CardContent,
  IconButton,
} from '@mui/material';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';

const ListLogs = () => {
  const redirect = useRedirect();

  const goDetail = (id) => {
    redirect(`/logs/${id}`);
  };

  return (
    <Card variant="elevation">
      <CardContent>
        <List actions={<CustomActions title="Logs" />}>
          {/* Filter bar under the title */}
          <FilterBar />

          <Datagrid
            bulkActionButtons={false}
            size="medium"
            sx={{
              borderTop: '1px solid grey',
              maxHeight: '60vh',
              overflow: 'auto',
            }}
          >
            <FunctionField
              label="NO"
              render={(record) => <IndexField record={record} />}
            />
            <RaTextField
              label="SITE"
              source="schedule.route.site.name"
              sortable={false}
            />
            <RaTextField
              label="ROUTE"
              source="schedule.route.name"
              sortable={false}
            />
            <ReferenceField
              label="OPERATOR"
              reference="cognitoUsers"
              source="operator_id"
              sortable={false}
            >
              <RaTextField label="" source="name" />
            </ReferenceField>
            <FunctionField
              label="CHECKPOINTS DONE"
              render={(record) =>
                record?.checkpoint_records?.items?.length ?? 0
              }
            />
            <DateField
              label="ENDED TIME"
              source="updatedAt"
              showTime
              sortable={false}
            />
            <FunctionField
              label="ACTION"
              render={(record) => (
                <IconButton onClick={() => goDetail(record.id)}>
                  <ErrorRoundedIcon />
                </IconButton>
              )}
            />
          </Datagrid>
        </List>
      </CardContent>
    </Card>
  );
};

export default ListLogs;
export { ListLogs };
